/**
 * 通用表单的vuex处理逻辑
 */
import service from '@/request/api'; // 导入api接口
import { Toast } from 'vant';
import moment from 'moment';
import jumpByStatusCommon from './routemap';

export default {
  namespaced: true,
  state: {
    /**
     * 通用外部变量 从detail或者本地存储获取的变量值
     */
    userId: localStorage.getItem('userId'),
    corpId: localStorage.getItem('corpId'),
    /**
     * 表单进件要素开始
     */
    orderId: localStorage.getItem('orderId') || '',
    productId: localStorage.getItem('productid') || '',
    loanAmount: '',
    termLoan: '',
    termLoanText: '',
    loanIntendedUse: '',
    loanIntendedUseText: '',
    referrer: '',
    support: '', // 邀请码是否可以修改
    corpName: '',
    taxNo: '',
    bizProvince: '',
    bizCity: '',
    bizCounty: '',
    bizAddress: '',
    bizAddressCode: '',
    locationText: '',
    legalName: '',
    legalIdentity: '',
    legalPhone: '',
    borrowerType: '',
    borrowerName: '',
    borrowerIdentity: '',
    borrowerPhone: '',
    borrowerEmail: '',
    borrowerLiveType: '',
    borrowerLiveTypeText: '',
    borrowerProvince: '',
    borrowerCity: '',
    borrowerCounty: '',
    borrowerAddress: '',
    borrowerAddressCode: '',
    livingText: '',
    bizPhone: '',
    education: '',
    educationText: '',
    marriage: '',
    marriageText: '',
    bankCard: '',
    creditBankCard: '',
    creditAccount: '',
    creditPassword: '',
    captcha: '',
    corpAuthContract: '',
    emergencyContact: '',
    relationshipWith: '',
    relationshipWithText: '',
    iceContactName: '',
    iceContactIdentity: '',
    iceContactPhone: '',
    creditCaptcha: '',
    onPerfectSaving: false, // 第一个进件数据提交中
    onLoaderSaving: false, // 第二个进件数据提交中
    agreeWithAgreement: 0, // 合同签署状态
    typeList: [], // 合同列表
    /**
     * 表单进件要素结束
     */
    productName: '',
    orderStatus: '',
    outterLink: '',
    canRetry: '',
    modalErrorReason: '',
    creditAmount: null,
    bwAmount: null,
    // 客户经理姓名
    pinganAccountManager: '',
    // 客户经理手机号
    pinganAccountManagerMobile: '',
    // 面签截止日期
    pinganDealLineTime: '',
    // 授信成功页面的额度和logo地址
    orgName: '',
    url: '',
    // 提款申请页面
    bankPhone: '',
    drawAmt: '',
    dateAmt: moment().format('YYYY-MM-DD hh:mm:ss'),
    bankName: '浦发',
    plat_name: '',
    rtnTypes: '',
    rtnTypesText: '',
    term: '',
    termText: '',
    usableAmount: 0.0,
    repayCardNo: '',
    IsloadingBox: true,
    Isloading: false,
    setInterval: null,
    ShowPopupContent: '',
    captchaType: '4',
    loanTermMap: [
      { text: '3个月', value: '3' },
      { text: '6个月', value: '6' },
      { text: '12个月', value: '12' },
    ],
    idNumber: '',
    accountName: '',
    bankNumber: '',
    phone: '',
    occupation: '',
    coreEnterpriseTaxNo: '',
    orderTime: '',
  },
  mutations: {
    updateForm(state, obj) {
      // eslint-disable-next-line
      for (let key in obj) {
        state[key] = obj[key];
      }
    },
  },
  actions: {
    // 获取产品信息接口
    productConfig(context) {
      const data = service.CommonForms.getProductConfig({
        productId: 'SPDB-FPD',
      });
      data.then((res) => {
        if (res.success) {
          if (res.data.length > 0 && res.data[0].data.length > 0) {
            context.commit('updateForm', {
              loanTermMap: res.data[0].data[1].values || [
                { text: '3个月', value: '3' },
                { text: '6个月', value: '6' },
                { text: '12个月', value: '12' },
              ],
            });
          }
        } else {
          Toast(res.returnMessage);
        }
      });
    },
    // 提款申请
    // eslint-disable-next-line consistent-return
    spdbDrawApply(context) {
      const {
        orderId,
        borrowerPhone,
        captcha,
        drawAmt,
        bankName,
        rtnTypes,
        term,
        usableAmount,
        captchaType,
      } = context.state;
      const reg1 = /^[1-9]\d{0,}$/;
      const reg2 = /^\d{6}$/;
      if (!reg1.test(drawAmt)) return Toast('申请金额格式输入有误,只能输入不以0开头的整数');
      if (!reg2.test(captcha)) return Toast('请输入6位数字的验证码');
      if (drawAmt * 1 <= usableAmount * 1) {
        context.commit('updateForm', {
          onLoaderSaving: true,
        });
        const data = service.CommonForms.spdbDrawApply({
          orderId,
          bankPhone: borrowerPhone,
          captcha,
          drawAmt,
          bankName,
          rtnTypes,
          term,
          captchaType,
        });
        data
          .then((res) => {
            if (res.success) {
              const setInter = setInterval(() => {
                context.dispatch('getSpdbDrawStatus', { context });
              }, 3000);
              context.commit('updateForm', {
                setInterval: setInter,
              });
            } else if (res.returnCode === '501') {
              context.commit('updateForm', {
                onLoaderSaving: false,
                ShowPopupContent: res.returnMessage,
              });
            } else if (res.returnCode === '500') {
              context.commit('updateForm', {
                onLoaderSaving: false,
              });
              Toast(res.returnMessage);
            }
          })
          .catch(() => {
            context.commit('updateForm', {
              onLoaderSaving: false,
            });
            Toast('小望已离开地球，请稍后重试！');
          });
      } else {
        Toast('输入金额不能大于可提款金额');
      }
    },
    // 进入页面首先判断是否可以再次申请提款
    isCanDrawing(context) {
      const { orderId } = context.state;
      context.commit('updateForm', {
        IsloadingBox: true,
      });
      const data = service.CommonForms.spdbCanApplyDraw({
        orderId,
      });
      data
        .then((res) => {
          if (!res.success) {
            const setInter = setInterval(() => {
              context.dispatch('getSpdbDrawStatus', { context });
            }, 3000);
            context.commit('updateForm', {
              setInterval: setInter,
            });
          } else {
            context.commit('updateForm', {
              IsloadingBox: false,
            });
            context.dispatch('getDrawerInfo', { context });
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    getSpdbDrawStatus(context) {
      const { orderId, setInterval } = context.state;
      const data = service.CommonForms.getSpdbDrawStatus({
        orderId,
      });
      data
        .then((res) => {
          if (res.success) {
            if (res.data.code === 102) {
              context.commit('updateForm', {
                IsloadingBox: false,
                onLoaderSaving: false,
                ShowPopupContent: res.data.message,
              });
              clearInterval(setInterval);
              context.dispatch('getDrawerInfo', { context });
            } else if (res.data.code === 103) {
              context.commit('updateForm', {
                IsloadingBox: false,
              });
              context.dispatch('nextJumpPage', { context });
              clearInterval(setInterval);
            }
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    // 提款申请
    getDrawerInfo(context) {
      const { orderId } = context.state;
      const data = service.CommonForms.getSpdbApplyDrawInfo({
        orderId,
      });
      data
        .then((res) => {
          if (res.success) {
            // eslint-disable-next-line no-shadow
            const { data } = res;
            context.commit('updateForm', {
              corpName: data.corpName,
              usableAmount: data.usableAmount,
              taxNo: data.taxNo,
              borrowerPhone: data.borrowerPhone,
              legalPhone: data.borrowerPhone,
              borrowerName: data.borrowerName,
              repayCardNo: data.repayCardNo,
            });
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    /**
     * 从服务器获取回显信息
     */
    // eslint-disable-next-line consistent-return
    fetchInfoFromServer(context) {
      const { orderId } = context.state;
      const info = service.CommonForms.getInformation(orderId);
      if (!info) {
        return Toast('小望已离开地球，请稍后重试！');
      }
      info
        .then((res) => {
          if (res && res.data) {
            // 借款期限
            const termMap = JSON.parse(localStorage.getItem('loanTermMap'))
              .values;
            // eslint-disable-next-line no-unused-expressions
            termMap
              && termMap.forEach((item) => {
                if (
                  res.data.termLoan
                  && item.value === res.data.termLoan.toString()
                ) {
                  context.commit('updateForm', {
                    termLoan: res.data.termLoan,
                    termLoanText: item.text,
                  });
                }
              });
            // 借款用途
            const loanIntendedUseMap = localStorage.getItem('loanIntendedUseMap')
              && JSON.parse(localStorage.getItem('loanIntendedUseMap')).values;
            // eslint-disable-next-line no-unused-expressions
            loanIntendedUseMap
              && loanIntendedUseMap.forEach((item) => {
                if (
                  res.data.loanIntendedUse
                  && item.value === res.data.loanIntendedUse.toString()
                ) {
                  context.commit('updateForm', {
                    loanIntendedUse: res.data.loanIntendedUse,
                    loanIntendedUseText: item.text,
                  });
                }
              });
            context.dispatch('updateCommon', {
              loanAmount: res.data.loanAmount,
              referrer: res.data.referrer,
            });
            // 企业所在地
            const tempLocationText = `${res.data.bizProvince} ${res.data.bizCity} ${res.data.bizCounty}`.trim();
            // 法人居住地
            const tempLivingText = `${res.data.borrowerProvince} ${res.data.borrowerCity} ${res.data.borrowerCounty}`.trim();
            const marriageAndRelationMap = localStorage.getItem('marriageAndRelationMap')
              && JSON.parse(localStorage.getItem('marriageAndRelationMap'));
            // 婚姻状况和紧急联系人关联框信息回显
            // eslint-disable-next-line no-unused-expressions
            marriageAndRelationMap
              && marriageAndRelationMap.valuesMarriageStatus.forEach((item) => {
                if (
                  res.data.marriage
                  && Number(item.value) === res.data.marriage
                ) {
                  context.commit('updateForm', {
                    marriageText: item.text,
                    marriage: res.data.marriage,
                  });
                }
              });
            // eslint-disable-next-line no-unused-expressions
            marriageAndRelationMap
              && marriageAndRelationMap.valuesEmerRelation.forEach((item) => {
                if (
                  res.data.relationshipWith
                  && item.value === res.data.relationshipWith.toString()
                ) {
                  context.commit('updateForm', {
                    relationshipWithText: item.text,
                    relationshipWith: res.data.relationshipWith,
                  });
                }
              });
            // 居住类型
            const borrowerLiveTypeMap = localStorage.getItem('borrowerLiveTypeMap')
              && JSON.parse(localStorage.getItem('borrowerLiveTypeMap'));
            // eslint-disable-next-line no-unused-expressions
            localStorage.getItem('borrowerLiveTypeMap')
              && borrowerLiveTypeMap.forEach((item) => {
                if (
                  res.data.borrowerLiveType
                  && item.value === res.data.borrowerLiveType.toString()
                ) {
                  context.commit('updateForm', {
                    borrowerLiveTypeText: item.text,
                    borrowerLiveType: res.data.borrowerLiveType,
                  });
                }
              });
            // 学历情况
            const educationMap = localStorage.getItem('educationMap')
              && JSON.parse(localStorage.getItem('educationMap'));
            // eslint-disable-next-line no-unused-expressions
            localStorage.getItem('educationMap')
              && educationMap.forEach((item) => {
                if (
                  res.data.education
                  && item.value === res.data.education.toString()
                ) {
                  console.log('educationMap', educationMap);
                  context.commit('updateForm', {
                    educationText: item.text,
                    education: res.data.education,
                  });
                }
              });
            // 紧急联系人关系（非关联）
            const relationshipWithMap = localStorage.getItem('relationshipWithMap')
              && JSON.parse(localStorage.getItem('relationshipWithMap'));
            // eslint-disable-next-line no-unused-expressions
            localStorage.getItem('relationshipWithMap')
              && relationshipWithMap.values.forEach((item) => {
                if (
                  res.data.relationshipWith
                  && item.value === res.data.relationshipWith.toString()
                ) {
                  context.commit('updateForm', {
                    relationshipWithText: item.text,
                    relationshipWith: res.data.relationshipWith,
                  });
                }
              });
            // 婚姻状况（非关联）
            const marriageMap = localStorage.getItem('marriageMap')
              && JSON.parse(localStorage.getItem('marriageMap'));
            // eslint-disable-next-line no-unused-expressions
            localStorage.getItem('marriageMap')
              && marriageMap.values.forEach((item) => {
                if (
                  res.data.marriage
                  && item.value === res.data.marriage.toString()
                ) {
                  context.commit('updateForm', {
                    marriageText: item.text,
                    marriage: res.data.marriage,
                  });
                }
              });
            console.log(res.data.bankCard, 'ooooooooo');
            context.dispatch('updateCommon', {
              // 地址
              captcha: '',
              bizAddress: res.data.bizAddress,
              // 邮编
              bizAddressCode: res.data.bizAddressCode,
              // 省份
              bizProvince: res.data.bizProvince,
              // 城市
              bizCity: res.data.bizCity,
              // 区
              bizCounty: res.data.bizCounty,
              locationText: tempLocationText,
              // 借款人相关信息
              borrowerAddress: res.data.borrowerAddress,
              borrowerAddressCode: res.data.borrowerAddressCode,
              borrowerProvince: res.data.borrowerProvince,
              borrowerCity: res.data.borrowerCity,
              borrowerCounty: res.data.borrowerCounty,
              borrowerEmail: res.data.borrowerEmail,
              livingText: tempLivingText,
              // 紧急联系人名称
              iceContactName: res.data.iceContactName,
              // 紧急联系人手机号
              iceContactIdentity: res.data.iceContactIdentity,
              // 紧急联系人手机号
              iceContactPhone: res.data.iceContactPhone,
              // 银行卡号
              bankCard: res.data.bankCard,
              // 信用卡号
              creditBankCard: res.creditBankCard || '',
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    updateCommon(context, data) {
      context.commit('updateForm', data);
    },
    /**
     * 更新InviteCode
     */
    updateInviteCode(context, data) {
      console.log(context, data);
      context.commit('updateForm', { referrer: data });
    },
    /**
     * 查询订单状态
     */
    checkCurrentStatus(context, { getInfo = false, isJump }) {
      const { orderId, productId } = context.state;
      service.CommonForms.getOrderStatus({ orderId })
        .then((res) => {
          if (res.success) {
            if (res.data.status) {
              const {
                status,
                refuseInfo = '',
                outterLink = '',
                borrowerName = '',
                corpName = '',
                canRetry = '',
                productName = '',
                creditAmount = '',
                otherData = null,
                bwAmount = '',
                // eslint-disable-next-line no-shadow
                orderId = '',
                orgName = '',
                url = '',
                orderTime = '',
              } = res.data;
              context.commit('updateForm', {
                orderStatus: status,
                modalErrorReason: refuseInfo,
                outterLink,
                productName,
                borrowerName,
                corpName,
                canRetry,
                creditAmount,
                orderId,
                orderTime,
                bwAmount,
                // 客户经理姓名
                pinganAccountManager:
                  otherData !== null ? otherData.pinganAccountManager : '',
                // 客户经理手机号
                pinganAccountManagerMobile:
                  otherData !== null
                    ? otherData.pinganAccountManagerMobile
                    : '',
                // 面签截止日期
                pinganDealLineTime:
                  otherData !== null ? otherData.pinganDealLineTime : '',
                orgName,
                url,
              });
              if (!getInfo) {
                jumpByStatusCommon(productId, res.data.status, orderId);
              }
              if (isJump === 'true') {
                if (res.data.status === '20004') {
                  context.dispatch('nextJumpPage', { context });
                } else {
                  context.dispatch('jumpMetthod', { context });
                }
              }
            }
          } else if (res.returnCode !== '10003') {
            if (res.returnMessage) {
              Toast({
                message: res.returnMessage || '小望已离开地球，请稍后重试！',
                forbidClick: true,
              });
            }
          }
        })
        .catch(() => {
          Toast.clear();
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    /**
     * 第二个进件页面获取法人信息
     */
    getBasicLegalInfo(context) {
      service.CommonForms.getCorpInfoInformation()
        .then((res) => {
          const {
            corpName,
            taxNo,
            legalName,
            legalIdentity,
            legalPhone,
          } = res.data;
          context.dispatch('updateCommon', {
            corpName,
            taxNo,
            legalName,
            legalIdentity,
            legalPhone,
            borrowerName: legalName,
            borrowerIdentity: legalIdentity,
            borrowerPhone: legalPhone,
          });
        })
        .catch(() => {
          context.commit('updateForm', {
            onLoaderSaving: false,
          });
        });
    },
    /**
     * 保存第二个进件页面
     */
    saveLoaderInfo(context) {
      context.commit('updateForm', {
        onLoaderSaving: true,
      });
      service.CommonForms.saveLoaderInfoInformation(context.state)
        .then((res) => {
          if (res.success === false) {
            Toast({
              message: res.returnMessage,
              forbidClick: true, // 背景不可点击
              onClose: () => {
                context.commit('updateForm', {
                  onLoaderSaving: false,
                });
              },
            });
          } else {
            context.commit('updateForm', {
              orderId: res.data.orderId,
            });
            context.dispatch('getModel', { context });
          }
        })
        .catch(() => {
          context.commit('updateForm', {
            onLoaderSaving: false,
          });
        });
    },
    /**
     * 跑模型
     */
    getModel(context) {
      const { orderId } = context.state;
      service.CommonForms.getModelRun({ orderId })
        .then((res) => {
          if (res.success === false) {
            Toast.clear();
            Toast({
              message: res.returnMessage,
              forbidClick: true, // 背景不可点击
              onClose: () => {
                context.commit('updateForm', {
                  onSaving: false,
                });
              },
            });
          } else {
            context.dispatch('checkCurrentStatus', { context });
          }
          context.commit('updateForm', {
            onSaving: false,
          });
        })
        .catch(() => {
          Toast.clear();
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    /**
     * 无法评估跑模型
     */
    getModelV2(context) {
      const { orderId } = context.state;
      service.CommonForms.getModelRunServer({ orderId })
        .then((res) => {
          console.log(res);
          if (res.success) {
            if (res.data.url) {
              window.location.href = res.data.url;
            }
          } else if (res.returnMessage) {
            Toast(res.returnMessage);
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    /**
     * 重置订单状态
     */
    resetOrder(context) {
      const { orderId } = context.state;
      service.CommonForms.rewriteWhenFailure({ orderId })
        .then((res) => {
          if (res.success) {
            context.commit('updateForm', {
              orderId: res.data.orderId,
            });
            localStorage.setItem('orderId', res.data.orderId);
            context.dispatch('checkCurrentStatus', { context });
          } else {
            Toast('重新填写失败');
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    // 跳转第三方页面
    jumpMetthod(context, params) {
      const { orderId } = context.state;
      const orderId1 = params?.orderId
      service.CommonForms.jumpThirdServer({
        orderId: orderId1 || orderId || localStorage.getItem('orderId'),
      }).then((res) => {
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        }
      });
    },
    nextJumpPage(context) {
      context.commit('updateForm', {
        Isloading: true,
      });
      const { orderId } = context.state;
      service.CommonForms.nextJumpPageServer({
        orderId: orderId || localStorage.getItem('orderId'),
      }).then((res) => {
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        } else {
          Toast(res.returnMessage);
        }
        context.commit('updateForm', {
          onLoaderSaving: false,
          Isloading: false,
        });
      });
    },
  },
  getters: {},
};
